var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","disabled":_vm.disabled || _vm.isFetching,"loading":_vm.isFetching},on:{"click":_vm.saveExcel}},[_vm._v(" Выгрузить в Excel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }